module.exports = __webpack_public_path__ + "img/监管平台-简介.798ac532.png";